module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/ParocCo2Calculator-0eb03400749f2e75f28aba063be10224.png";